<template>
  <div v-if="ask.comments" class="mt-10">
    <md-card id="commentDivSection">
      <md-card-expand >
        <md-card-actions md-alignment="space-between"  ref="commentDivSection" >
          <md-card-expand-trigger>
            <md-button class="expand-button-size"><strong><span @click="expandChild('comment')" class="upper-word">Comments <span>({{ask.comments.length}})</span></span></strong></md-button>
          </md-card-expand-trigger>
        </md-card-actions>
        <md-card-expand-content>
          <md-card-content class="comments" v-if="this.$parent.opened.includes('comment')">
            <div class="comments">
                <div
              	v-if="ask.comments && ask.comments.length"
                v-for="(comment,index) in sortComments"
                class="activity"
                :key="'comment-'+index">
	                  <b>{{ comment.when | momentDate }} - {{ comment.memberName }}</b>
	                  <p class="ask-description">{{ comment.comment }}</p>
              </div>
            </div>
            <div>
                <form @submit.prevent="submitComment">
                    <md-field class="create-ask textareaAfter">
                        <md-textarea v-model="commentText" @input="commentText = sanitizeInput($event)" class="md-textarea padding-left-10" placeholder="Enter your comment"></md-textarea>
                    </md-field>
                    <md-field class="create-ask">
                        <md-button class="md-accent md-raised upper-word md-white-color" type="submit">Add Comment</md-button>
                    </md-field>
                </form>
            </div>
          </md-card-content>
        </md-card-expand-content>
      </md-card-expand>
    </md-card>
  </div>
</template>
<!-- Script-->
<script>
import { sanitizeInput } from '@/utils/sanitizer';
export default {
  name: "Comments",
  props: ["ask", "opened", "comment"],
  data() {
    return {
      commentText: ''
    }
  },
  computed: {
    sortComments: function() {
      if (this.ask.comments) {
      	let comments = this.ask.comments.slice()
        return comments.sort((a, b) => {
          return a.when < b.when ? 1 : -1;
        });
      }
    }
  },
  methods: {
    sanitizeInput(event) {
      return sanitizeInput(event);
    },
    expandChild(id) {
    	this.$parent.expand('comment')
    },
    submitComment($event) {
        this.$parent.addComment($event);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Comments.vue